<template>
  <div class="terminal-order-table">
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column fixed prop="outTradeNo" label="订单编号" width="200" show-overflow-tooltip />
      <el-table-column prop="transactionId" label="商户单号" width="200" show-overflow-tooltip />
      <el-table-column prop="appName" label="来源渠道" width="250" show-overflow-tooltip />
      <el-table-column prop="openId" label="openid/设备ID" width="180" align="left" header-align="left" show-overflow-tooltip />
      
      <el-table-column prop="buyTypeName" label="购买方式" width="100" />
      <el-table-column prop="goodsTypeName" label="商品类型" width="130" />
      <el-table-column prop="goodsName" label="商品名称" width="200" show-overflow-tooltip />
      
      <el-table-column label="订单状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="getOrderStatusTag(scope.row.status)">
            {{ scope.row.statusName }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="orderCreateTime" label="下单时间" width="180" sortable />
      
      <el-table-column prop="goodsPrice" label="商品价格(元)" width="150" align="right" />
      <el-table-column prop="goodsNum" label="订单数量" align="right" />
      <el-table-column prop="totalPayFee" label="支付金额(元)" width="150" align="right" />
      
      <el-table-column prop="payTimeEnd" label="支付时间" width="180" sortable>
        <template slot-scope="scope">
          {{ scope.row.payTimeEnd || '-' }}
        </template>
      </el-table-column>

      <el-table-column prop="payTypeName" label="支付方式" />

      <el-table-column prop="refundTime" label="退款时间" width="240" />
      
      <el-table-column label="退款状态" width="100">
        <template slot-scope="scope">
            {{ getRefundStatusDesc(scope.row.refundStatus) }}
        </template>
      </el-table-column>

      <el-table-column label="退款金额(元)" width="160">
        <template slot-scope="scope">
          {{ (+scope.row.refundFee) / 100 }}
        </template>
      </el-table-column>

      <el-table-column prop="hotelInfo" label="备注" width="240" show-overflow-tooltip />

      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="canRefund(scope.row)"
            type="text"
            size="small"
            icon="el-icon-edit"
            @click="handleRefund(scope.row)"
            v-auth="'TERMINAL_ORDER_REFUND'"
          >
            申请退款
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TerminalOrderTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getOrderStatusTag(status) {
      const map = {
        0: 'info',      // 未支付
        1: 'success',   // 已支付
        2: 'danger',    // 支付失败
        3: 'warning',    // 记账
        4: 'warning'    // 待生成记账
      }
      return map[status] || ''
    },
    getRefundStatusDesc(status) {
        const map = {
            0: '未申请',
            1: '已退款', // 注意：Option.js里 value:1 是已退款
            2: '退款失败',
            3: '拒绝退款',
            5: '申请退款', // 待处理
            6: '退款中'
        }
        // 注意：这里跟之前的 map 有点出入，我是根据 option.js 的内容覆盖的
        // option.js: 1:已退款, 2:退款失败, 3:拒绝退款, 5:申请退款, 6:退款中
        // 但 index.vue 里之前的代码注释也需要参考
        return map[status] || '-'
    },
    canRefund(row) {
      // 状态为已支付(1)，非乐视支付，且退款状态允许
      // index.vue: scope.row.status === 1 && scope.row.payType !== 'leshiPay' && (scope.row.refundStatus !== 1 && scope.row.refundStatus !== 5 && scope.row.refundStatus !== 6)
      // 根据 option.js: 1=已退款, 5=申请退款, 6=退款中. 所以不能退款的状态是 已退款(1)、申请退款(5)、退款中(6)。这逻辑是对的。
      return row.status === 1 && 
             row.payType !== 'leshiPay' && 
             (row.refundStatus !== 1 && row.refundStatus !== 5 && row.refundStatus !== 6)
    },
    handleRefund(row) {
      this.$emit('refund', row)
    }
  }
}
</script>
